<h1 class="title">Inventory</h1>
<h5>Manage Inventory</h5>
<div class="cas-wrapper">
    <ng-container *ngIf="!loading else showLoading">
        <div class="cas-pad">
            <ng-container *ngIf="financeEnabled else notEnabled">
            <acabim-datatable
                #dataTable
                [dataSources]="dataSources"
                (showDetail)="handleDataSource(true)"
                [hasDetailView]="true"></acabim-datatable>
            <div class="cas-action-buttons">
                <button
                    class="cas-button-action"
                    data-cy="_t-add-inventory-start"
                    (click)="openAddItemModal()">Add</button>
            </div>
            </ng-container>
        </div>
    </ng-container>
</div>

<ng-container *ngIf="showAddInventoryModal">
    <acabim-modal
        [title]="'Add an inventory item'"
        fixHeight="75vh"
        (status)="closeAddModal($event)"
        [display]="showAddInventoryModal">
        <acabim-admin-add-inventory (closeModal)="closeAddItemModal($event)"></acabim-admin-add-inventory>
    </acabim-modal>
</ng-container>

<ng-container *ngIf="showEditInventoryModal">
    <acabim-modal
        [title]="'Edit inventory item'"
        fixHeight="75vh"
        (status)="closeEditModal($event)"
        [display]="showEditInventoryModal">
        <acabim-admin-add-inventory (closeModal)="closeEditItemModal($event)" [existingLineItem]="dataSources[0].detailData"></acabim-admin-add-inventory>
    </acabim-modal>
</ng-container>

<ng-template #notEnabled>
    <div class="cas-error">
        <h3>Financial services are not enabled</h3>
        <p>You need to enable financial services in order to add inventory.</p>
        <p><button class="cas-button-action" (click)="goToFinSettings()">Enable</button></p>
    </div>
</ng-template>

<ng-template #showLoading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
